
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'

const ProjectUpdate = ({ visible, setVisible, formValues, setFormValues, option, upsertProfile }) => {

    return (
        <div>
            <Dialog visible={visible?.project_change} onHide={() => setVisible((prev) => ({ ...prev, project_change: false }))} className='modal-xsmall' draggable={false} header="Edit Project & Technology" style={{ width: "60vw" }}>
                <div className='row mx-0 px-0'>
                    <div className='col-12 my-1'>
                        <label>Select Primary Project</label>
                        <Dropdown
                            className="input-dd"
                            options={option?.projectOpt}
                            optionLabel="project_name"
                            value={formValues?.primaryProject?.value || null}
                            onChange={(e) => { setFormValues((prev) => ({ ...prev, primaryProject: { value: { ...e.value }, isChange: true }, })) }}
                            placeholder="Primary Project"
                            filter
                            filterInputAutoFocus
                            name="primaryProject"
                        />
                    </div>
                    {/* {
                        projectModules?.length > 0 && <div className='col-12 my-1'>
                            <label>Select Project Module</label>
                            <Dropdown
                                className="input-dd"
                                options={projectModules}
                                optionLabel="option_value"
                                value={formValues?.projectModule}
                                onChange={(e) => setFormValues((prev) => ({ ...prev, projectModule: { value: { ...e.value }, isChange: true }, }))}
                                placeholder="Project Module"
                                showClear
                                filter
                                filterInputAutoFocus
                                name="projectModule"
                            />
                        </div>
                    } */}

                    <div className='col-12 my-1'>
                        <label>Select Primary Skill</label>
                        <Dropdown
                            className="input-dd"
                            options={option?.technologiesOpt}
                            optionLabel="primary_skill_1"
                            value={formValues?.technologie?.value || null}
                            onChange={(e) => setFormValues((prev) => ({ ...prev, technologie: { value: { ...e.value }, isChange: true }, isChange: true }))}
                            placeholder="Primary Technologie"
                            filter
                            filterInputAutoFocus
                            name="technologie"
                        />
                    </div>
                    <div className='d-flex gap-2 justify-content-end'>
                        <button className='sk-btn sk-btn-primary' onClick={() => setVisible((prev) => ({ ...prev, project_change: false }))}>Cancel</button>
                        <button className='sk-btn bg-black text-white sk-btn-primary' onClick={upsertProfile}>Submit</button>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default ProjectUpdate
